import type { CollectionResponse } from '@guildrise/shared';
import { fetchCollection, getAuthRevision } from '../../shared/api.js';

// Только успешные ответы в памяти вкладки, отдельно для каждой гильдии.
const cache = new Map<string, CollectionResponse>();
const requests = new Map<string, symbol>();
let cacheRevision = getAuthRevision();

function syncSession(): void {
  if (cacheRevision === getAuthRevision()) return;
  cacheRevision = getAuthRevision();
  cache.clear();
  requests.clear();
}

export function readCollection(guildId: string): CollectionResponse | undefined {
  syncSession();
  return cache.get(guildId);
}

export async function loadCollection(
  guildId: string,
  signal: AbortSignal,
): Promise<CollectionResponse> {
  signal.throwIfAborted();
  syncSession();
  const request = Symbol();
  requests.set(guildId, request);
  try {
    // Кеш — только первый кадр. Каждый вход проверяет сервер, включая права доступа.
    const collection = await fetchCollection(signal);
    signal.throwIfAborted();
    syncSession();
    if (requests.get(guildId) !== request) {
      throw new DOMException('Загрузка устарела', 'AbortError');
    }
    cache.set(guildId, collection);
    return collection;
  } catch (error) {
    syncSession();
    if (!signal.aborted && requests.get(guildId) === request) cache.delete(guildId);
    throw error;
  } finally {
    if (requests.get(guildId) === request) requests.delete(guildId);
  }
}
